/*
 * @author: Mater
 * @Email: bxh8640@gmail.com
 * @Date: 2021-08-23 17:16:32
 * @Description:
 */
import env from '../env'
import { onceIn } from '../utils'

const driverBizConfig = {}

const driverBizHonghuConfig = {
    shareWeixinAppmsg: {
        support: '1.7.0'
    },
    shareWeixinTimeline: {
        support: '1.7.0'
    },
    shareSMS: {
        support: '999'
    },
    launchScan: {
        support: '999'
    },
    scanQrCode: {
        support: '999'
    },
    initEntrance: {
        support: '999'
    },
    invokeEntrance: {
        support: '999'
    },
    hideEntrance: {
        support: '999'
    },
    showEntrance: {
        support: '999'
    },
    startCarRequest: {
        support: '1.0.0'
    },
    toHomePage: {
        support: '1.0.0'
    },
    closePage: {
        support: '1.0.0'
    },
    chooseContact: {
        support: '999'
    },
    photograph: {
        support: '999'
    },
    chooseImage: {
        support: '1.0.0'
    },
    orderDetailInfo: {
        support: '999'
    },
    orderReassignState: {
        support: '999'
    },
    checkOrderDetail: {
        support: '999'
    },
    orderTripEnd: {
        support: '999'
    },
    getUserInfo: {
        support: '1.0.0',
        prepare: function (params, cb) {
            const BRIDGE_TIMEOUT = 2000
            let fn = function (result) {
                // iOS返回的是字符串
                if (typeof result === 'string') {
                    result = JSON.parse(result)
                }
                cb(result)
            }
            // 300ms内没有返回就callback
            const wrappedFn = onceIn(fn, BRIDGE_TIMEOUT)
            return ['getUserInfo', {}, wrappedFn]
        }
    },
    getSystemInfo: {
        support: '999'
    },
    getDeviceMarkInfo: {
        support: '999'
    },
    getLocationInfo: {
        support: '1.0.0'
    },
    launchNav: {
        support: '999'
    },
    addCornerButton: {
        support: '1.0.0'
    },
    resetBack: {
        support: '999'
    },
    getHydraData: {
        support: '999'
    },
    requestLogout: {
        support: '1.0.0'
    },
    openPage: {
        support: '1.0.0'
    },
    wxPayRequest: {
        support: '999'
    },
    open19PayPage: {
        support: '999'
    },
    commonPay: {
        support: '999'
    },
    viewIsBackground: {
        support: '999'
    },
    setTitle: {
        support: '1.0.0'
    },
    launchIm: {
        support: '999'
    },
    showImEntrance: {
        support: '999'
    },
    faceRecognize: {
        support: '1.0.0'
    },
    controlBackPress: {
        support: '1.0.0'
    },
    resizeImage: {
        support: '999'
    },
    getA3Token: {
        support: '999'
    },
    shareFacebook: {
        support: '999'
    },
    shareLine: {
        support: '999'
    },
    shareWhatsApp: {
        support: '999'
    },
    shareTwitter: {
        support: '999'
    },
    shareEmail: {
        support: '999'
    },
    shareFBMessenger: {
        support: '999'
    },
    startRecord: {
        support: '999'
    },
    callPassengerPhone: {
        support: '999'
    },
    doInterceptVerify: {
        support: '1.0.0'
    },
    endRecord: {
        support: '999'
    },
    playVoice: {
        support: '999'
    },
    stopVoice: {
        support: '999'
    },
    addFee: {
        support: '999'
    },
    confirmProtocol: {
        support: '999'
    },
    checkRecordPermis: {
        support: '999'
    },
    requestRecordPermis: {
        support: '999'
    },
    openPermisSettingPage: {
        support: '999'
    },
    closeCarRequest: {
        support: '999'
    },
    statisticsPageLoadTime: {
        support: '999'
    },
    unioneOrderOfflinePay: {
        support: '999'
    },
    showCommendRobot: {
        support: '999'
    },
    onPageStop: {
        support: '999'
    },
    callUpVoIP: {
        support: '999'
    },
    davCaptureVideo: {
        support: '999'
    },
    davPlayVideo: {
        support: '999'
    },
    wechatCardAuthAction: {
        support: '999'
    },
    getCurrentOrderStatus: {
        support: '999'
    },
    saveImage: {
        support: '1.7.0'
    },
    requestCameraPermission: {
        support: '999'
    },
    requestRecordPermission: {
        support: '999'
    },
    playTts: {
        support: '999'
    },
    stopTts: {
        support: '999'
    },
    videoInterviewPart: {
        support: '999'
    },
    bodyTest: {
        support: '999'
    },
    startInterview: {
        support: '999'
    },
    travelShare: {
        support: '999'
    },
    oneAlarm: {
        support: '999'
    },
    trackEvent: {
        support: '999'
    },
    startGuideRecognize: {
        support: '999'
    },
    cancelGuideRecognize: {
        support: '999'
    },
    navigationShowOrHide: {
        support: '999'
    },
    getWsgInfo: {
        support: '1.0.0'
    },
    screenshot: {
        support: '999'
    },
    requireLocationPermisstion: {
        support: '999'
    },
    goTravelDetail: {
        support: '1.0.0'
    },
    cancelLoading: {
        support: '1.0.0'
    },
    openCardOcr2: {
        support: '1.0.0'
    },
    brick: {
        support: '1.0.0'
    },
    getTheme: {
        support: '1.0.0'
    }
}

export default (env.isHonghu ? driverBizHonghuConfig : driverBizConfig)
